import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const getOrgMarketPlacesOptions = (orgId: string) =>
  queryOptions({
    queryKey: ["orgMarketplaces", orgId],
    queryFn: async () => await apiClient.getOrganizationMarketplaces({ params: { orgId } }),
  });
